<template>
  <CRow>
    <CCol xl="12" lg="12" md="12" style="margin-top: 20%" v-if="loading">
      <div
        class="sk-wave primary"
        color="success"
        style="margin: auto; width: 10%; top: 50% !important"
      >
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
      </div>
    </CCol>
    <CCol col="12" md="12" v-if="!loading">
      <CCard style="top: 10px">
        <CCardHeader>
          <!-- <p> -->
          <!-- <DatePicker
              v-model="value1"
              type="date"
              range
              placeholder="Select date range"
              style="float: left"
            ></DatePicker> -->

          <!-- <CButton
              block
              color="success"
              style="float: right; width: 100px"
              @click="wizard()"
            >
              <i class="fa fa-plus" aria-hidden="true"></i> Add new</CButton
            > -->
          <!-- </p> -->
        </CCardHeader>
        <CCardBody>
          <CDataTable
            pagination
            clickable-rows
            hover
            :fields="fields"
            :items="tableData"
          >
            <template #image="{ item }">
              <td>
                <img :Src="item.image" class="icon" />
              </td>
            </template>
            <template #Action="{ item }">
              <td>
                <span class="badge badge-success" v-if="item.approved"
                  >Approved</span
                >
                <CButton
                  v-if="!item.approved"
                  color="success"
                  variant="outline"
                  square
                  size="sm"
                  @click="Approve(item.docId)"
                >
                  Approve </CButton
                ><br /><br />
              </td>
            </template>
            <template #View="{ item }">
              <td>
                <CButton
                  color="primary"
                  variant="outline"
                  square
                  size="sm"
                  style="width: 54px"
                  @click="viewGameDetails(item)"
                >
                  View </CButton
                ><br /><br />
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<style src="spinkit/spinkit.min.css"></style>

<script>
import VueElementLoading from "vue-element-loading";

import CTableWrapper from "../tables/Table";
import firebase from "firebase";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";
import Swal from "sweetalert2";

const db = firebase.firestore();
export default {
  components: { CTableWrapper, DatePicker, VueElementLoading },
  data() {
    return {
      value1: [],
      tableData: [],
      loading: true,
      fields: [
        {
          label: "Logo",
          key: "image",
          sortable: true,
        },
        {
          label: "User",
          key: "user",
          sortable: true,
        },
        {
          label: "Game Name",
          key: "name",
          sortable: true,
        },
        {
          label: "created",
          key: "created",
          sortable: true,
        },
        {
          key: "Action",
          sortable: true,
        },
        {
          key: "View",
          sortable: true,
        },
      ],
    };
  },
  watch: {},
  methods: {
    wizard() {
      this.$router.push({ name: "CreateGame" });
    },
    showMessage(msg, icon) {
      Swal.fire({
        position: "center",
        icon: icon,
        title: msg,
        showConfirmButton: false,
        timer: 3000,
      });
    },
    approveGame(item) {
      console.log("items approved");
      //   this.$router.push({
      //     name: "editGame",
      //     params: { id: item.id },
      //   });
    },
    async Approve(docId) {
      this.loading = true;
      // console.log("approsdcsdfsdfs", docId);
      const token = await firebase.auth().currentUser.getIdToken();

      const headers = {
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          "x-access-token": token,
        },
      };
      try {
        const response = await axios.post(
          "https://us-central1-token-geomine.cloudfunctions.net/api/approveGame",
          {
            docId,
          },
          headers
        );
        console.log("response", response);
        if (response.data.Status == true) {
          this.loading = false;
          this.showMessage("Approved Successfully", "success");
          window.location.reload();
        } else {
          this.loading = false;
          this.showMessage("Error while Apporve", "warning");
        }
      } catch (error) {
        this.loading = false;
        console.log("error", error);
        this.showMessage("Error while Updating Game", "warning");
      }
    },
    viewGameDetails(item) {
      this.$router.push({
        name: "ViewApproval",
        params: { id: item.id },
      });
    },
    async getGames() {
      this.tableData = [];
      //   const user = await firebase.auth().currentUser;
      //   console.log("usersssss", user);

      db.collection("gamesCategoriesV2")
        .get()
        .then((snapshot) => {
          this.tableData = [];
          snapshot.forEach((doc) => {
            // console.log("dataaa", doc.data());
            this.tableData.push(this.assignsmallData(doc));
          });
          this.loading = false;
        })
        .catch((e) => {
          console.log("errror", e);
          this.loading = false;
        });
    },
    assignsmallData(doc) {
      let smallDocument = {
        image: doc.data().thumbnail,
        name: doc.data().title,
        url: doc.data().url,
        user: doc.data().user,
        docId: doc.id,
        approved: doc.data().approved,
        created: moment(doc.data().createdTime.seconds * 1000).format(
          "DD-MMM-YYYY , hh:mm:ss:a"
        ),
        id: doc.id,
      };
      return smallDocument;
    },
  },
  created() {
    this.getGames();
  },
};
</script>

<style>
.icon {
  width: 50px;
  height: 50px;
  border-radius: 50px;
}
.play-button {
  color: #26994d;
  text-decoration: none;
}
.play-button:hover {
  color: #fff;
  text-decoration: none;
}
</style>
